module.exports = __webpack_public_path__ + "media/images/logo_medium-4831899e5358fb30619e221daa78bf61.svg";